import { render, staticRenderFns } from "./AffiliatesList.vue?vue&type=template&id=27d8c4db&"
import script from "./AffiliatesList.vue?vue&type=script&lang=ts&"
export * from "./AffiliatesList.vue?vue&type=script&lang=ts&"
import style0 from "@/style/components/affiliate/affiliates-list.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports